import React from 'react';
import styled from '@emotion/styled';
import Link from 'gatsby-link';
import ReactMarkdown from 'react-markdown';
import DescriptionComponent from './description.component';
import CaseComponent, { SmallCaseComponent } from './case.component';
import throttle from 'lodash.throttle';
import { lineHeight, responsiveFontSize } from 'style';

const DescriptionPlusCaselistComponent = ({
    id,
    descriptionLabel,
    descriptionBody,
    featuredCases,
    additionalCases,
}) => (
    <div className="wrapper" id="DescriptionPlusCaselistComponent">
        <div className="container-fluid">
        <div className="row">
            <div className="col-xs-12 col-lg-3">
                <DescriptionComponent
                    descriptionLabel={descriptionLabel}
                    descriptionBody={descriptionBody}
                />
                <SmallMoreCaseStudiesLink data-cursor="focus" data-cursor-persistance="500">
                    <Link to={'/work'} className='arrow-link'>View more cases</Link>
                </SmallMoreCaseStudiesLink>
            </div>
            <div className="col-xs-12 col-lg-8 col-lg-offset-1">
                <CasesRow className="row">
                    {featuredCases.map(ccase => (
                        <div
                            key={`${id}${ccase.name}`}
                            className="col-xs-12 col-sm-6"
                            style={{ opacity: 1 }}>
                            <CaseComponent {...ccase} />
                        </div>
                    ))}
                    <hr />
                </CasesRow>
            {/* <CaseAccordion cases={additionalCases} id={id} /> */}
                <MoreCaseStudiesLink data-cursor="focus" data-cursor-persistance="500">
                    <Link to={'/work'} className='arrow-link'>View more cases</Link>
                </MoreCaseStudiesLink>
            </div>
        </div>
        </div>
    </div>
);

class CaseAccordion extends React.PureComponent {
    constructor() {
        super();

        this.state = {
            open: false,
            maxHeight: 0,
        };

        this.morestudiesWrapper = React.createRef();

        this.toggle = this.toggle.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleResizeThrottled = throttle(this.handleResize, 250);
    }
    componentDidMount() {
        this.addEventListeners();
    }
    componentWillUnmount() {
        this.removeEventListeners();
    }
    addEventListeners() {
        window.addEventListener('resize', this.handleResizeThrottled);
    }
    removeEventListeners() {
        window.removeEventListener('resize', this.handleResizeThrottled);
    }
    handleResize() {
        this.setState({
            maxHeight: this.getMaxHeight(),
        });
    }

    getMaxHeight() {
        return (
            this.morestudiesWrapper.current.getBoundingClientRect().height + 10
        );
    }
    toggle() {
        this.setState({
            open: !this.state.open,
            maxHeight: this.getMaxHeight(),
        });
    }
    render() {
        const { open, maxHeight } = this.state;
        return (
            <>
            <div gutters="0" className="">
                
            <ViewMoreCaseStudies
                    data-cursor="focus"
                    data-cursor-persistance="200"
                    className={open ? 'open' : ''}
                    onClick={this.toggle}>
                    View more case studies
                </ViewMoreCaseStudies>


                <MoreCaseStudies style={{ maxHeight: open ? maxHeight : 0 }}>
                    <div ref={this.morestudiesWrapper} className="row">
                        {this.props.cases.map(ccase => (
                            <div
                                key={`${this.props.id}${ccase.name}`}
                                className="col-sm-6">
                                <SmallCaseComponent {...ccase} />
                            </div>
                        ))}
                    </div>
                </MoreCaseStudies>
            </div>
            </>
            
        );
    }
}
const CasesRow = styled.div`
    @media (max-width: 1024px){
        margin-top: 32px;
        // flex-wrap: nowrap;
        // overflow: scroll;
        // .col{
        //     width: 250px;
        //     flex: 1 0 250px;
        //     max-width: 250px;
        // }
    }
`
const ViewMoreCaseStudies = styled.div`
    position: relative;
    display: inline-block;
    padding-bottom: 2.25em;

    &:after {
        content: '+';
        font-size: 1.2em;
        position: absolute;
        line-height: 1;
        left: 100%;
        top: 0;
        margin-left: 1em;
    }

    &.open:after {
        content: '—';
    }
`;
const MoreCaseStudies = styled.div`
    position: relative;
    overflow: hidden;
    transition: max-height 200ms ease-out;
    margin: 0 -20px;
    padding: 0 20px;
`;
const SmallMoreCaseStudiesLink = styled.div`
    
    display: none;
    @media (min-width: 1025px){
        display: block;
    }
    a{
      margin-top: 2rem;
      padding-top: 20px;
      padding-bottom: 20px;
    }
`;
const MoreCaseStudiesLink = styled.div`
        
    display: block;
    @media (min-width: 1025px){
        display: none;
    }
    a{
        // position: relative;
        // display: block;
        // padding: 20px 0;
        // border-top: 1px solid rgba(0,0,0,0.14);
        // border-bottom: 1px solid rgba(0,0,0,0.14);
        // text-decoration: none;
    }
    // a:after {
    //     content: '→';
    //     font-size: 1.2em;
    //     position: absolute;
    //     line-height: 1;
    //     right: 0;
    //     margin-left: 1em;
    // }
`;

export default DescriptionPlusCaselistComponent;
